import Vue from 'vue';
import { Toast } from 'patsnap-biz';
import { messageBox } from '@/infrastructure/utils/messageBox';
import { deleteViewDataApi } from '@cores/apis/workspace_api/viewData';
import { DetailServiceSymbol } from '@/services/DetailService';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
import { useFormatRefiner } from '@/presentation/pages/detail/basic/hooks/useFormatRefiner';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { useFolder } from '@/presentation/composables/folder/use-folder';
import { useFolderSetting } from '@/presentation/pages/workspace-detail/composables/use-folder-setting';
export function useRemoveViewDataConfirm() {
    const i18n = injectService(i18nSymbol);
    const detailService = injectService(DetailServiceSymbol);
    const pageSelectorService = injectService(PageSelectorServiceSymbol);
    const { folderId } = useFolder();
    const { currentSort } = useFolderSetting();
    // eslint-disable-next-line no-async-promise-executor
    const state = new Promise(async (resolve) => {
        const { close, instance } = messageBox({
            title: i18n.t('workspace.viewData.delete'),
            message: i18n.t(`workspace.viewData.${detailService.detailType}.deleteMsg`, { count: pageSelectorService.selectedCount }),
            dialogProps: { width: '500px' },
            confirmButtonProps: {
                loading: false,
                'data-type': 'danger',
            },
            confirmButtonText: i18n.t('global.btn.delete'),
            callback: (action) => {
                if (action === 'cancel') {
                    close();
                    resolve(false);
                    return;
                }
                Vue.set(instance.confirmButtonProps, 'loading', true);
                deleteViewDataApi({
                    data_type: detailService.viewDataType,
                    folder_id: folderId.value,
                    select_mode: pageSelectorService.mode,
                    doc_ids: pageSelectorService.mode === 'INCLUDE' ? pageSelectorService.selectedIds : pageSelectorService.deselectedIds,
                    refiner: useFormatRefiner(),
                    start: pageSelectorService.rangeFrom,
                    end: pageSelectorService.rangeTo,
                    sort: currentSort.value,
                })
                    .then(() => {
                    Vue.set(instance.confirmButtonProps, 'loading', false);
                    Toast({
                        type: 'success',
                        message: i18n.t('workspace.viewData.deleteViewDataTaskTip'),
                        dangerouslyUseHTMLString: true,
                        showClose: true,
                        duration: 5000,
                    });
                    close();
                    resolve(true);
                })
                    .catch((error) => {
                    Vue.set(instance.confirmButtonProps, 'loading', false);
                    if (!error._error_msg)
                        return;
                    Toast({
                        showClose: true,
                        type: 'error',
                        message: error._error_msg,
                        duration: 5000,
                    });
                });
            },
        });
    });
    return { state };
}
